export default function searchhandler() {
	const searchArray = Array.from(document.querySelectorAll('.search'));
	const searchButtonArray = Array.from(
		document.querySelectorAll('.search__icon')
	);
	const searchOverlayArray = Array.from(
		document.querySelectorAll('.search__overlay')
	);

	// searchButton.addEventListener('click', function () {
	//   console.log('click');
	//   // searchArray.forEach(function (search) {
	//   //   search.classList.toggle('search__open');
	//   // })
	// })

	searchButtonArray.forEach(function (searchButton) {
		searchButton.addEventListener('click', function () {
			//  console.log('click');
			searchArray.forEach(function (search) {
				search.classList.toggle('search__open');
			});
		});
	});

	searchOverlayArray.forEach(function (searchOverlay) {
		searchOverlay.addEventListener('click', function () {
			searchArray.forEach(function (search) {
				search.classList.remove('search__open');
			});
		});
	});
}
